import styled from 'styled-components';

export const Wrapper = styled.div`
    color: #404b5a;
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 48px;
    text-align: center;
`;
